module.exports = __webpack_public_path__ + "img/mehmet-kirciii@2x.e82d7de8.png";